var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "btns",
    class: _vm.current == 1 ? "left" : "",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticClass: "btn",
    class: _vm.current == 0 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(0);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("健康告知")))]), _c("div", {
    staticClass: "btn",
    class: _vm.current == 1 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("条款文件")))])]), _vm.current == 0 ? _c("div", {
    staticStyle: {
      margin: "15px 10px",
      color: "#1890ff"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("说明：当前产品无健康告知时，请点击切换进行条款配置，否则无法进入下一流程页面。")) + " ")]) : _vm._e(), _vm.current === 0 ? _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      margin: "20px 0 10px"
    }
  }, [_vm._v(_vm._s(_vm.$t("文本内容")) + "：")]), _c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "400px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.healthNotice,
      callback: function ($$v) {
        _vm.healthNotice = $$v;
      },
      expression: "healthNotice"
    }
  })], 1) : _vm._e(), _vm.current === 1 ? _c("div", {
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "20px"
    }
  }, [_c("a-checkbox", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      checked: _vm.checked
    },
    on: {
      change: _vm.changeChecked
    }
  }, [_vm._v(_vm._s(_vm.$t("当前产品无条款文件")))]), _c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 20
      },
      rules: _vm.rules
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 18
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("文件名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      disabled: _vm.checked
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 18
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("条款文件"),
      prop: "link"
    }
  }, [_c("a-upload", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      action: _vm.action,
      multiple: false,
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      data: {
        module: "insuranceTerms"
      },
      accept: ".pdf",
      fileList: _vm.fileList,
      showUploadList: {
        showRemoveIcon: false
      },
      disabled: _vm.uploadStatus
    },
    on: {
      change: _vm.handleChange
    }
  }, [_c("a-button", [_c("a-icon", {
    attrs: {
      type: "upload"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("选择文件")) + " ")], 1)], 1), _c("span", [_vm._v("*" + _vm._s(_vm.$t("仅支持上传PDF格式文件，最大不超10M")))])], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 18
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("文本内容"),
      prop: "content"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor2",
    staticStyle: {
      height: "500px"
    },
    attrs: {
      options: _vm.quillOption,
      disabled: _vm.checked
    },
    model: {
      value: _vm.form.content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  }), _c("div", {
    staticClass: "right"
  })], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "btnBox",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.checked,
      loading: _vm.saveTermLoading
    },
    on: {
      click: _vm.saveList
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("文件确认")))])]), _c("div", {
    staticClass: "table-div"
  }, [_c("a-table", {
    attrs: {
      size: "small",
      tableLayout: "fixed",
      pagination: false,
      rowKey: "id",
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "linkName",
      fn: function (text, record) {
        return [_c("span", {
          staticStyle: {
            color: "#1890ff",
            cursor: "pointer"
          },
          on: {
            click: function ($event) {
              return _vm.onPreview(record);
            }
          }
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "operation",
      fn: function (_, record, index) {
        return [_c("a-button", {
          staticStyle: {
            "margin-right": "20px"
          },
          attrs: {
            size: "small",
            disabled: _vm.checked,
            type: "edit"
          },
          on: {
            click: function ($event) {
              return _vm.editList(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _c("a-button", {
          attrs: {
            size: "small",
            disabled: _vm.checked,
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.delList(record.insuranceTermsId, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }], null, false, 3440479766)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1)], 1) : _vm._e(), _vm.termsShow ? _c("terms-model", {
    ref: "termsRef",
    on: {
      ok: _vm.updateTermsFun,
      cancel: function ($event) {
        _vm.termsShow = false;
      }
    }
  }) : _vm._e(), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      click: _vm.prevFun
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.disabled,
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };